import React, { useRef, useState } from 'react'
import { PrimaryButton, SecondaryButton2th } from '../../components/StyledButtons'
import arrow_down from "../../assets/images/icons/arrow_down_cyan_16px.svg"
import arrow_down_white from "../../assets/images/icons/arrow_down_white_16px.svg"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import ModalContactDiscussionForm from './../../components/ModalContactDiscussionForm';
import ModalPricingOnPremise from './ModalPricingOnPremise'

const PricingOnPremise = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  const handleScroll = () => {
    const targetElement = document.getElementById('targetSection');
    if (targetElement) {
      const yOffset = 0;
      const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
  const [modalOnPremiseOpen, setModalOnPremiseOpen] = useState(false)

  const modalDiscussionRef = useRef(null);
  const modalOnPremiseRef = useRef(null)
  
  const handleOverlayClick = (event) => {
    if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
      setModalDiscussionOpen(false)
    }
    if (modalOnPremiseRef.current && !modalOnPremiseRef.current.contains(event.target)) {
      setModalOnPremiseOpen(false)
    }
    
  };

  document.onkeydown = function (evt) {
    if (evt.code === 'Escape') {
      setModalDiscussionOpen(false)
      setModalOnPremiseOpen(false)

    }
  };

  return (
    <div className='pricing_on-premise container'>
      <div className='row'>
        <div className='col-sm-12 col-md-6 col-lg-4'>
          <div className='pricing-card'>

            {language === "en"
              ?
              <div>
                <p className='font-20 font-weight-medium'>Trial</p>
                <p className='font-32 pt-10 font-weight-medium'>14 Days</p>
                <ul className='list-unstyled pt-30'>
                  <li className="checked-line">1,000 API calls/day</li>
                  <li className="checked-line">No size limit per Code</li>
                  <li className="checked-line">EDC generation, revocation & update</li>
                  <li className="checked-line">PDC generation</li>
                </ul>
              </div>
              :
              <div>
                <p className='font-20 font-weight-medium'>Thử nghiệm</p>
                <p className='font-32 pt-10 font-weight-medium'>14 ngày</p>
                <ul className='list-unstyled pt-30'>
                  <li className="checked-line">1.000 lệnh gọi API/ngày</li>
                  <li className="checked-line">Không giới hạn kích thước cho mỗi Mã</li>
                  <li className="checked-line">Tạo, thu hồi và cập nhật EDC</li>
                  <li className="checked-line">Tạo PDC</li>
                </ul>
              </div>
            }

            <div className='flex justify-center align-center pt-50 flex-column'>
              <SecondaryButton2th style={{ fontSize: "14px" }}>{t('button.get-started')}</SecondaryButton2th>
              <div className='flex'>
                <p className='see-all-features pt-10 text-primary-cyan' onClick={handleScroll}>{t('button.see-all-features')}</p>
                <img src={arrow_down} alt="arrow_down_16px" className='mt-10 ml-5' />
              </div>
            </div>

          </div>
        </div>
        <div className='col-sm-12 col-md-6 col-lg-4'>
          <div className='pricing-card-popular'>
            <div className='popular-chip'>
              {language === "en"
                ?
                <p>MOST POPULAR</p>
                :
                <p>PHỔ BIẾN NHẤT</p>
              }
            </div>
            {language === "en"
              ?
              <div>
                <p className='font-20 font-weight-medium'>PRO</p>
                <p className='pt-10 font-weight-medium'><span className='font-weight-semi-bold font-32'>$8000 </span>/Year</p>
                <ul className='list-unstyled pt-30'>
                  <li className="checked-line-secondary">1,000 API calls/day</li>
                  <li className="checked-line-secondary">No size limit per Code</li>
                  <li className="checked-line-secondary">EDC generation, revocation & update</li>
                  <li className="checked-line-secondary">PDC generation</li>
                  <li className="checked-line-secondary">Business Hours Support</li>
                </ul>
              </div>
              :
              <div>
                <p className='font-20 font-weight-medium'>Chuyên nghiệp</p>
                <p className='pt-10 font-weight-medium'><span className='font-weight-semi-bold font-32'>$8000 </span>/Năm</p>
                <ul className='list-unstyled pt-30'>
                  <li className="checked-line-secondary">1.000 lệnh gọi API/ngày</li>
                  <li className="checked-line-secondary">Không giới hạn kích thước cho mỗi Mã</li>
                  <li className="checked-line-secondary">Tạo, thu hồi và cập nhật EDC</li>
                  <li className="checked-line-secondary">Tạo PDC</li>
                  <li className="checked-line-secondary">Hỗ trợ giờ làm việc</li>
                </ul>
              </div>
            }

            <div className='flex justify-center align-center pt-50 flex-column'>
              <PrimaryButton style={{ fontSize: "14px" }}
                onClick={() => setModalOnPremiseOpen(true)}
              >{t('button.schedule-demo')}</PrimaryButton>
              <div className='flex'>
                <p className='see-all-features pt-10' onClick={handleScroll}>{t('button.see-all-features')}</p>
                <img src={arrow_down_white} alt="arrow_down_16px" className='mt-10 ml-5' />
              </div>
            </div>

          </div>
        </div>
        <div className='col-sm-12 col-md-6 col-lg-4'>
          <div className='pricing-card'>
            {language === "en"
              ?
              <div>
                <p className='font-20 font-weight-medium'>Enterprise</p>
                <p className='font-32 pt-10 font-weight-medium'>Contact Us</p>
                <ul className='list-unstyled pt-30'>
                  <li className="checked-line">Multiple Instances</li>
                  <li className="checked-line">Pre-post Processing</li>
                  <li className="checked-line">Archiving</li>
                  <li className="checked-line">TLS Authentication</li>
                  <li className="checked-line">HSM Integration</li>
                  <li className='checked-line'>24/7 Support</li>
                </ul>
              </div>
              :
              <div>
                <p className='font-20 font-weight-medium'>Doanh nghiệp</p>
                <p className='font-32 pt-10 font-weight-medium'>Liên hệ chúng tôi</p>
                <ul className='list-unstyled pt-30'>
                  <li className="checked-line">Nhiều trường hợp</li>
                  <li className="checked-line">Xử lý trước sau</li>
                  <li className="checked-line">Lưu trữ</li>
                  <li className="checked-line">Xác thực TLS</li>
                  <li className="checked-line">Tích hợp HSM</li>
                  <li className='checked-line'>Hỗ trợ 24/7</li>
                </ul>
              </div>
            }

            <div className='flex justify-center align-center pt-50 flex-column'>
              <SecondaryButton2th style={{ fontSize: "14px" }}
                onClick={() => setModalDiscussionOpen(true)}
              >{t('button.contact-us')}</SecondaryButton2th>
              <div className='flex'>
                <p className='see-all-features pt-10 text-primary-cyan' onClick={handleScroll}>{t('button.see-all-features')}</p>
                <img src={arrow_down} alt="arrow_down_16px" className='mt-10 ml-5' />
              </div>
            </div>

          </div>
        </div>
        {language === "en" ?
          <div className='col-sm-12 text-center'>
            <p className='font-weight-medium text-white'><span className='font-weight-semi-bold'>Note:</span> Requirements: x86-64 Linux physical or virtual machine or cloud instance with at-least 512MB RAM and 8GB disk</p>
            <p className='italic text-gray'>All prices are in USD</p>
          </div>
          :
          <div className='col-sm-12 text-center'>
            <p className='font-weight-medium text-white'><span className='font-weight-semi-bold'>Lưu ý:</span> Yêu cầu: x86-64 Linux vật lý hoặc máy ảo hoặc phiên bản đám mây có RAM tối thiểu 512MB và ổ đĩa 8GB</p>
            <p className='italic text-gray'>Tất cả giá đều tính bằng USD</p>
          </div>
        }
      </div>
      {modalDiscussionOpen && <ModalContactDiscussionForm
        setOpenModal={setModalDiscussionOpen}
        handleOverlayClick={handleOverlayClick}
        modalRef={modalDiscussionRef} />}
      {modalOnPremiseOpen && <ModalPricingOnPremise
        setOpenModal={setModalOnPremiseOpen}
        handleOverlayClick={handleOverlayClick}
        modalRef={modalOnPremiseRef} />}
    </div>
  )
}

export default PricingOnPremise